import {
  Component,
  inject,
  input,
  InputSignal,
  output,
  OutputEmitterRef,
  Signal,
} from '@angular/core';
import { ButtonComponent } from '../../../../components/feedback/button/button.component';
import { SectionComponent } from '../../../../components/layout/section/section.component';
import {
  EEntityType,
  ERelationType,
  DEFAULT_CUSTOM_TILE_SUBSCRIPTION,
  ICustomTile,
  DEFAULT_ACCESSIBLE_IMAGE_EMPTY,
  ETextType,
  LanguagePrefix,
} from '@web/dtos';
import {
  FormArray,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { ICustomTileSectionForm } from '../../../../entities/custom-tile-section.entity';
import { StartPageCardBlockComponent } from '../start-page-card-block/start-page-card-block.component';
import { ICustomTileForm } from '../../../../entities/custom-tile.entity';
import { SectionHeaderComponent } from '../../../../components/layout/section/section-header/section-header.component';
import { TranslationTextInputComponent } from '../../../../components/data-input/form-inputs/translation-text-input/translation-text-input.component';
import { CustomTileSectionFormsFactoryService } from '../../../../factory/customTileSection/custom-tile-section-forms-factory';
import { SectionHeadlineComponent } from '../../../../components/layout/section/section-header/section-headline/section-headline.component';
import { CustomTileSectionStore } from '../../../../services/api/custom-tile-section/custom-tile-section-store.service';
import { LanguagePipe } from '../../../../pipes/language/language.pipe';
import { LoadingAnimationComponent } from '../../../../components/feedback/loading-animation/loading-animation.component';
import { CmsTextProviderService } from '../../../../services/cms-text-provider.service';

@Component({
  selector: 'aw-start-page-section-block',
  templateUrl: './start-page-section-block.component.html',
  imports: [
    ButtonComponent,
    SectionComponent,
    FormsModule,
    ReactiveFormsModule,
    StartPageCardBlockComponent,
    SectionHeaderComponent,
    TranslationTextInputComponent,
    SectionHeadlineComponent,
    LanguagePipe,
    LoadingAnimationComponent,
  ],
})
export class StartPageSectionBlockComponent {
  public readonly id: InputSignal<string> = input.required();
  public readonly sectionIndex: InputSignal<number> = input.required();
  public readonly lastIndex: InputSignal<number> = input.required();
  public readonly startPageSectionForm: InputSignal<
    FormGroup<ICustomTileSectionForm>
  > = input.required();

  public customTileSectionStore: CustomTileSectionStore = inject(
    CustomTileSectionStore
  );
  public readonly atDeleteSection: OutputEmitterRef<string | null> = output<
    string | null
  >();
  public readonly moveSections: OutputEmitterRef<{
    oldIndex: number;
    newIndex: number;
  }> = output<{
    oldIndex: number;
    newIndex: number;
  }>();
  protected readonly customTileSectionFactory: CustomTileSectionFormsFactoryService =
    inject(CustomTileSectionFormsFactoryService);
  protected readonly cmsTextProvider: CmsTextProviderService = inject(
    CmsTextProviderService
  );

  public readonly atDelete: OutputEmitterRef<FormGroup<ICustomTileForm>> =
    output<FormGroup<ICustomTileForm>>();

  protected readonly TextRelationType: typeof ERelationType = ERelationType;
  protected readonly EntityType: typeof EEntityType = EEntityType;

  protected readonly isLoading: Signal<boolean> =
    this.customTileSectionStore.isLoading;

  addCard() {
    this.startPageSectionForm().controls.tiles.push(
      this.customTileSectionFactory.buildCustomTileFormGroup({
        isActive: true,
        accessibleImage: DEFAULT_ACCESSIBLE_IMAGE_EMPTY,
        texts: [
          {
            textType: ETextType.Web,
            text: {
              values: [
                {
                  value:
                    'Karte ' +
                    (this.startPageSectionForm().controls.tiles.length + 1),
                  languagePrefix: 'DE' as LanguagePrefix,
                },
              ],
            },
            relationType: ERelationType.title,
            entityType: ERelationType.customTile,
          },
          {
            textType: ETextType.Web,
            text: {
              values: [
                {
                  value: '',
                  languagePrefix: 'DE' as LanguagePrefix,
                },
              ],
            },
            relationType: ERelationType.descriptionText,
            entityType: ERelationType.customTile,
          },
          {
            textType: ETextType.Web,
            text: {
              values: [
                {
                  value: '',
                  languagePrefix: 'DE' as LanguagePrefix,
                },
              ],
            },
            relationType: ERelationType.iconText,
            entityType: ERelationType.customTile,
          },
        ],
      })
    );
    this.startPageSectionForm().markAsDirty();
  }

  deleteCard(index: number, tiles: FormArray): void {
    tiles.removeAt(index);
    this.startPageSectionForm().markAsDirty();
  }
}
